import Context from './Context.js';

export default class Content extends Context {
  constructor(areas, layout) {
    super();
    this.data = {
      co_ar: areas,
      co_la: layout
    };
  }

  static get key() {
    return 'content_event_context'
  }
}
